export default "__VITE_ASSET__DwOBtpsN__"